<template>
  <div class="nav">
        <ul class="navlist">
            <li :class="[activeNav==-1?'active':'']"><i class="iconfont icon-user"></i></li>
            <li><i class="iconfont icon-collection"></i></li>
            <li>
                <ul class="collectlist">
                    <li v-for="(item,index) in collect" :key="item.id" :class="[activeNav==index?'active':'']"><i :class="['iconfont',item.iconName]"></i></li>
                </ul>
            </li>
            <li><span class="iconfont">&#58885;</span></li>
        </ul>
        <div class="tabbox" :style="{'margin-left':(!navStable ? '10px': '170px')}">
            <el-tabs v-model="routeName" type="card"  @tab-remove="removeTab" @tab-click="gototab">
                <el-tab-pane
                    v-for="item in editableTabs"
                    :key="item.moduleName"
                    :label="item.path"
                    :closable="item.close"
                    :name="item.moduleName">
                    <span slot="label"><i @click="refresh($route.name)" class="rotate el-icon-refresh"></i> {{item.moduleName}}</span>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="navLayer" @mouseenter="sliderUnfold" @mouseleave="sliderFold"> <!-- 添加navLayer这层是为了防止滑动到上面的tab时而触发事件 -->
            <Bookmarks :slide="fold" @pathPush="addTab"/>   
        </div>
  </div>
</template>
<script>
import { mapGetters , mapMutations } from 'vuex'
import { Mixins } from '@/config/mixins/mixins'
import { $http } from '@/config/api/axios'
import across from "@/config/components/across.js"
import Bookmarks from './Bookmarks'
export default {
    name:'Aside',
    inject:['reload'],
    mixins:[Mixins],
    components:{
        Bookmarks,
    },
    computed:{
        ...mapGetters('Home', [
            'keepAlive',
            'navStable',
            'collect',
            'activeNav',
        ]),
    },
    data() {
        return {
            routeName: '',
            editableTabs: [],// 打开的tab集合
            closable:false,
            fold:false,
            keepArr: ['controller','controller-en'],
            enModuleIncludes:[],
        }
    },
    methods: {
        ...mapMutations('Home', [
            'SET_KEEP_ALIVE',
            'SET_ACTIVE_NAV',
            'SET_FRESH_NAME',
        ]),
        setNavIndex(rtPath){
            let actindex = -2;
            rtPath = rtPath.substring(1)
            if(rtPath === 'controller'){
                actindex = -1
            }
            this.collect.forEach((item,index)=>{
                if(item.path === rtPath){
                    actindex = index
                }
            })
            this.SET_ACTIVE_NAV(actindex)
        },
        addTab(routeObj) {
            let targetPath = routeObj.path
            let targetName = this.$i18n.locale === "zh" ? routeObj.moduleName : routeObj.moduleEnName
            let flag = true
            this.closable = true
            if(this.$route.path == "/"+targetPath){
                return
            }
            this.editableTabs.forEach((item)=>{
                if(item.path === targetPath){
                    flag = false;
                    return
                }
            })
            if(flag){
                if(this.editableTabs.length>=10){
                    this.$i18n.locale === "zh" ? this.msgwarning('系统最多允许打开10个功能页面。')
                    : this.msgwarning('The system allows up to 10 feature pages to be opened.')
                    this.setNavIndex(this.$route.path)
                    return
                }
                this.editableTabs.push({
                    path: targetPath,
                    moduleName: targetName,
                    close:true,
                });

                if(this.$root.$lang === 'en-US'){
                    if(this.enModuleIncludes.includes(targetPath.toLowerCase())){
                        this.keepArr.push(targetPath+'-en');
                    }else{
                        this.keepArr.push(targetPath);
                    }
                }else{
                    this.keepArr.push(targetPath);
                }
                this.SET_KEEP_ALIVE(this.keepArr)
                // 新打开页面时需调用接口一次埋点
                // 传递参数有路径URL，模块id，屏幕分辨率
                this.accessControl(routeObj.id)
            }
            this.$router.push({path:`/${this.$root.$lang}/`+targetPath})
            this.routeName = targetName;
        },
        gototab(ins){
            let routePath = ins.label
            this.$router.push({path:routePath})
            this.setNavIndex('/'+routePath)
        },
        removeTab(targetName) {
            let routePathRemoved;
            let tabs = this.editableTabs;
            let activeName = this.routeName;
            tabs.forEach((tab,index)=>{
                if(tab.moduleName === targetName){
                    routePathRemoved = tab.path;
                    if (activeName === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.moduleName
                            this.$router.push({path:nextTab.path})
                        }
                    }
                }
            })
            this.routeName = activeName;
            this.editableTabs = tabs.filter(tab => tab.moduleName !== targetName);
            if(this.$root.$lang === 'en-US'){
                this.keepArr = this.keepArr.filter(name=>{
                    if(name.includes('-en')){
                        return name !== routePathRemoved+"-en"; // en-US中的路由
                    }else{
                        return name !== routePathRemoved; // common中的路由
                    }
                })
            }else{
                this.keepArr = this.keepArr.filter(name => name !== routePathRemoved);
            }
            this.SET_KEEP_ALIVE(this.keepArr)
            let removedIndex = -2
            if(activeName === '控制台' || activeName === 'Controller'){
                this.SET_ACTIVE_NAV(-1)
            }else{
                this.collect.forEach((item,actindex)=>{
                    if(item.moduleName === activeName){
                        removedIndex = actindex
                    }
                })
                this.SET_ACTIVE_NAV(removedIndex)
            }
        },
        sliderUnfold(ev){
            if(!this.navStable){
                this.fold = true
            }
        },
        sliderFold(){
            if(!this.navStable){
                this.fold = false
            }
        },
        refresh(moduleName){
            let popIndex;
            this.keepAlive.forEach((ele,index) => {
                if(ele.toLowerCase() === moduleName){
                    popIndex = index
                    this.SET_FRESH_NAME(ele)
                }
            });
            this.keepAlive.splice(popIndex,1)
            this.reload()
        },
        forbidBack(){
            history.pushState(null, null, document.URL);
        },
        accessControl(id){
            const clientResolution = window.screen.width+'x'+window.screen.height;
            const moduleId = id;
            const requestUrl = this.$route.fullPath;
            const skinId = localStorage.getItem('echartsTheme') === 'theme1' ? '1' : '2';
            $http('post','visitStatistics/insertVisit',{ // 访问审计
                moduleId,
                requestUrl,
                clientResolution,
                skinId
            }).then(res=>{})
        }
    },
    created(){
        if(this.$root.$lang === 'en-US'){
            this.$router.options.routes.forEach(R=>{
                if(R.name === 'Home-en'){
                    R.enList.forEach(path=>{
                        this.enModuleIncludes.push(path)
                    })
                }
            })
        }
    },
    mounted(){
        switch(this.$root.$lang){ // tab中英文初始化时push数据
            case 'zh-CN':
                this.editableTabs.push({
                    path:'controller',
                    moduleName:'控制台',
                    close:false,
                })
                this.routeName = '控制台'
            break;
            case 'en-US':
                this.editableTabs.push({
                    path:'controller',
                    moduleName:'Controller',
                    close:false,
                })
                this.routeName = 'Controller'
            break;
        }
        across.$off('addCollect')
        across.$on('addCollect',(options,arg)=>{ // across主要用于传递事件
            if(arg === 'isOpen'){ // 不收藏直接打开
                this.addTab(options)
            }
        })
        if (window.history && window.history.pushState) {
            window.addEventListener('popstate', this.forbidBack, false);
        }
    },
    destroyed(){
        window.removeEventListener('popstate', this.forbidBack, false);
    }
}
</script>

<style lang="less">
.nav{
    position: relative;
    display: flex;
    height: 100%;
    width: 40px;
    border-radius: 0px 4px 4px 0px;
    box-shadow: 0px 0px 5px rgba(68, 48, 96, 0.2);
    .navlist{
        width: 100%;
        display: flex;
        flex-direction: column;
        li{
            font-size: 20px;
            height: 40px;
            width: 40px;
            text-align:center;
            line-height: 40px;
            &:last-child{
                margin-top: auto;
            }
            &.active{
                color: #4980d7;
            }
            i.iconfont{
                font-size: 18px;
            }
            .collectlist{
                height: calc(100vh - 188px);
                overflow: hidden;
                li{
                    border: none !important;
                }
            }
        }
    }
    .tabbox{
        height: 28px;
        margin-left: 10px;
        transition: all .4s;
       .el-tabs__item{
            border-radius: 3px;
            margin-right: 4px;
            height: 28px;
            line-height: 28px;
            box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
            border-bottom: none !important;
            border-left: none !important;
        }
        
        .el-tabs__header .el-tabs__nav,.el-tabs--card>.el-tabs__header{
            border: none !important;
        }
        .el-tabs__header{
            margin: 0;
        }
        .el-tabs__nav-wrap{
            overflow:initial;
        }
        .el-tabs__nav-scroll{
            overflow: initial;
        }
    }
    .navLayer{
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 100%;
    }
    .rotate{
        transition: transform 0.3s ease-in-out;
        &:hover{
            transform: rotate(180deg);
        }
    }
    .el-tabs__item .el-icon-close{
        transition: width .3s cubic-bezier(.645,.045,.355,1);
    }
}
</style>